<template>
  <article class="">
    <div class="table_card mb-5">
      <div class="table_card__head">
        <p class="table_card__head--title">
          Asociar dispositivo
        </p>
      </div>
      <div class="table_card__body">
        <v-layout row wrap>
          <v-flex xs12 lg6 class="pr-3">
            <label
              class="table_card__info--label"
              :class="{ 'custom_input__title--colapsed': data.uuid != '' }"
            >
              {{ data.device_type == 15 || data.device_type == 16 ? 'Placa' : 'UUID' }}
            </label>
            <input
              class="faccess_input"
              :class="{ 'custom_input__inputs--open': data.uuid != '' }"
              type="text"
              v-model="data.uuid"
            />
          </v-flex>
          <v-flex xs12 lg6 class="pl-3">
            <label
              class="table_card__info--label"
              :class="{ 'custom_input__title--colapsed': data.device_type != '' }"
            >
              Tipo de dispositivo
            </label>
            <v-select
              style="margin-top: 10px;"
              :items="device_options"
              :item-text="'name'"
              :item-value="'id'"
              v-model="data.device_type"
              @change="showValue()"
            ></v-select>
          </v-flex>
        </v-layout>
        <button
          type="button"
          class="faccess_button access_devices__button"
          @click="create_access_device()"
          :disabled="validate_fields"
        >Asociar</button>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  data(){
    return{
      device_options:[{name:'Tag', id: 5}, {name:'Tarjeta', id: 6}, {name:'Sticker', id: 7}, {name:'Manilla', id: 8}, {name: 'Carro', id: 15}, {name: 'Moto', id: 16}, {name:'Otro', id: 11}],
      data:{
        uuid: '',
        device_type: 5,
        user_id: '',
        uuidFormat:'',
        company: this.getCompany().id
      }
    }
  },
  computed:{
    validate_fields(){
      if (this.data.uuid == '' || this.data.device_type == '' || this.data.user_id == ''){
        return true
      } else {
        return false
      }
    }
  },
  mounted(){
    console.log(this.$route);
    this.data.user_id = Number(this.$route.params.user_id)
  },

  watch: {
      'data.uuid'(newValue){
        if(this.data.device_type == 15 || this.data.device_type == 16){
          this.data.uuid = newValue.toUpperCase();
        }
      },

      'data.device_type'(newValue){
        if(newValue == 15 || newValue == 16){
          this.data.uuid = this.data.uuid.toUpperCase();
        }
      }
  },

  methods:{
    showValue(){
      console.log(this.data.device_type);
    },
    create_access_device(){

      var hex = this.data.uuid.match(/.{1,2}/g)
      var res = []
      var uuidFormat = ''

      for(var i=0; i<hex.length; i++){
        res.unshift(hex[i])
      }

      if(parseInt(res.toString().replaceAll(',', ''), 16).toString().length < 10){
        uuidFormat = '0' + parseInt(res.toString().replaceAll(',', ''), 16).toString()
      }else{
        uuidFormat = parseInt(res.toString().replaceAll(',', ''), 16).toString()
      }

      console.log('uuidFormat', uuidFormat)

      this.data.uuidFormat = uuidFormat

      console.log('this.data', this.data)

      let data = {
        attributes: this.data
      }
      try {
        this.$http.post('app/access_devices/create',
          {
            data: this.encrypt(data).toString()
          },{
          headers: {
              "X-Device-ID" : this.getDeviceId(),
              "Authorization" : 'Bearer ' + this.getUserToken()
          },
        }).then(function(response){
          console.log(response);
          this.$router.push({name:"access_devices"})
          this.updateAlertMessage('Dispositivo asociado')
          this.updateIsInAlert(true);
        }, function(response){
          console.log(response);
          this.updateAlertMessage(response.body.data.message)
          this.updateIsInAlert(true);
        })
      } catch (e) {
        this.updateAlertMessage(e.message)
        this.updateIsInAlert(true);
      }
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/views/users/access_devices/CreateAccessDevice.vue